export enum PoniesModalType {
  CREATE_NEW_ADDRESS = 'CREATE_NEW_ADDRESS',
  DELETE_ADDRESS = 'DELETE_ADDRESS',
  DELETE_CARD = 'DELETE_CARD',
  CANCEL_CORE = 'CANCEL_CORE',
  ORDER_DETAILS = 'ORDER_DETAILS',
  PAYMENT_INFO = 'PAYMENT_INFO',
  CANCEL_SUBSCRIPTION = 'CANCEL_SUBSCRIPTION',
}
